import { render, staticRenderFns } from "./CreateLogo.vue?vue&type=template&id=23cfbf33&"
import script from "./CreateLogo.vue?vue&type=script&lang=ts&"
export * from "./CreateLogo.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports